module.exports = {
      id: "rain-usage",
      viewBox: "0 0 38.4 27.718",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#rain",
      toString: function () {
        return this.url;
      }
    }